import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth-store';
import { ExternalUserDashboardPage } from '../../features/external-user-dashboard/pages/ExternalUserDashboardPage';

export const DashboardPage: React.FC = () => {
  const { currentUser } = useAuthStore();
  const navigate = useNavigate();

  const isExternalUser = currentUser?.type === 'EXTERNAL';

  // Vérifier les permissions
  const hasContractCreatePermission = currentUser?.permissions?.includes('contract.create') ?? false;
  const hasContractListPermission = currentUser?.permissions?.includes('contract.list') ?? false;

  const handleCreateContract = () => {
    navigate('/contracts/create');
  };

  const handleViewContracts = () => {
    navigate('/contracts');
  };

  return (
    <div>
      {/* Welcome Banner - EXTERNAL users only */}
      {isExternalUser && (
        <div className="tw-w-full tw-bg-gradient-to-r tw-from-affinicar-primary tw-to-affinicar-secondary tw-px-4 sm:tw-px-6 tw-py-4 tw-shadow-md">
          <div className="tw-max-w-7xl tw-mx-auto tw-flex tw-flex-col sm:tw-flex-row tw-items-start sm:tw-items-center tw-justify-between tw-gap-3">
            <div>
              <h2 className="tw-text-lg sm:tw-text-xl tw-font-bold tw-text-white tw-mb-1">
                Bienvenue, {currentUser?.firstname} !
              </h2>
              <p className="tw-text-sm tw-text-white tw-text-opacity-90">
                Votre tableau de bord des performances
              </p>
            </div>
            <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-2 sm:tw-gap-3 tw-w-full sm:tw-w-auto">
              {hasContractCreatePermission && (
                <button
                  onClick={handleCreateContract}
                  className="tw-bg-white tw-text-affinicar-primary tw-px-5 tw-py-2 tw-rounded-lg tw-font-semibold hover:tw-bg-affinicar-lighter tw-transition-colors tw-shadow-md tw-text-sm tw-w-full sm:tw-w-auto tw-text-center"
                >
                  Créer un contrat
                </button>
              )}
              {hasContractListPermission && (
                <button
                  onClick={handleViewContracts}
                  className="tw-bg-white tw-text-affinicar-primary tw-px-5 tw-py-2 tw-rounded-lg tw-font-semibold hover:tw-bg-affinicar-lighter tw-transition-colors tw-shadow-md tw-text-sm tw-w-full sm:tw-w-auto tw-text-center"
                >
                  Voir la liste des contrats
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Dashboard vendeur externe */}
      {isExternalUser && <ExternalUserDashboardPage />}

      {/* Message pour utilisateurs internes */}
      {!isExternalUser && (
        <div className="tw-max-w-7xl tw-mx-auto tw-px-4 tw-text-center tw-py-20">
          <h2 className="tw-text-2xl tw-font-semibold tw-text-gray-700">
            Tableau de bord en cours de création
          </h2>
        </div>
      )}
    </div>
  );
};

